import { Box, Text, VStack } from '@genial/components';
import React from 'react';

import { useRecoilQuery } from '../../../../../hooks/useRecoilQuery';
import { fixedFeeNewContractTermQuery } from '../../../../../store/fixedFee/selector';
import { FixedFeeNewContractStepOneData } from '../../types';

import { StepTwoContractInfo } from './components/StepTwoContractInfo';
import { StepTwoSendingChannel } from './components/StepTwoSendingChannel';
import { StepTwoTermContent } from './components/StepTwoTermContent';

interface StepTwoSummaryProps {
  stepOneData: FixedFeeNewContractStepOneData;
  shouldLoadTerm: boolean;
  onTermLoaded: () => void;
  onSendingChannelsChange: (channels: string[]) => void;
}

export const StepTwoSummary: React.FC<StepTwoSummaryProps> = ({
  stepOneData,
  shouldLoadTerm,
  onTermLoaded,
  onSendingChannelsChange,
}) => {
  const { data: termDataState, loading: loadingTermData } = useRecoilQuery(
    fixedFeeNewContractTermQuery({
      accountNumber: stepOneData.selectedCustomer!.accountNumber,
      excludeEquity: stepOneData.excludeEquity,
      feePercentage: stepOneData.rate,
    }),
    {
      if: () => shouldLoadTerm && !!stepOneData.selectedCustomer,
      cachePolicy: 'no-cache',
    }
  );

  const termData = termDataState?.data;

  React.useEffect(() => {
    if (termData) {
      onTermLoaded();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [termData]);

  return (
    <VStack space="stack.xxxs">
      <Text variant="semibold" fontSize="lg">
        Resumo da contratação
      </Text>

      <StepTwoContractInfo stepOneData={stepOneData} />
      <StepTwoSendingChannel
        selectedChannels={stepOneData.sendingChannelsSelected}
        onSelectionChange={onSendingChannelsChange}
      />
      <Box h="1px" w="full" bg="neutral.lightest" />
      <StepTwoTermContent loading={loadingTermData} htmlContent={termData?.htmlContent} />
    </VStack>
  );
};
